import { NotificationTypeDTO } from 'business/models/Models';

export const NotificationTypes: NotificationTypeDTO[] = [
  new NotificationTypeDTO({
    id: 1,
    name: 'None',
  }),
  new NotificationTypeDTO({
    id: 2,
    name: 'Immediate',
  }),
  new NotificationTypeDTO({
    id: 3,
    name: 'DailyDigest',
  }),
];

export enum EUserAction {
  ProtienLayer = 'Protien',
  ScreenLayer = 'Screen',
  ImageNow = 'imageNow',
  GridLayer = 'GridLayer',
  CustomLayer = 'CustomLayer',
  CustomLayerScreen = 'CustomLayerScreen',
  SeedingLayer = 'Seeding',
  RandomLayer = 'RandomLayer',
  EditExperiment = 'EditExperiment',
  Optimization = 'Optimization',
  InstantDropReport = 'InstantDropReport',
  ExperimentReport = 'ExperimentReport',
  DesignReport = 'DesignReport',
  IngredientReport = 'IngredientReport',
  ImageReport = 'ImageReport',
  SingleDropReport = 'SingleDropReport',
  WellReport = 'WellReport',
  ScoreReport = 'ScoreReport',
  SynchrotronTripReport = 'SynchrotronTripReport',
  ScreenStockReport = 'ScreenStockReport',
  MarkAsDispensed = 'MarkAsDispensed',
  FragmentLayer = 'Fragment Screen',
  SynchrotronTrip = 'SynchrotronTrip',
  Imaging = 'Imaging',
  SendToMarco = 'SendToMarco',
}

export enum EKeyCodes {
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
  Delete = 46,
}

export enum LogicalOperator {
  And = 'and',
  Or = 'or',
}

export interface MatchParams {
  // location: history.location;
  // history: history.history;
  staticcontext?: any;
}

export interface match<p> {
  params: p;
  isexact: boolean;
  path: string;
  url: string;
}

export type Coordinates = {
  x: number;
  y: number;
};

export type Dimensions = {
  width: number;
  height: number;
};

export type RGBColor = {
  r: number;
  g: number;
  b: number;
};

type Enumerate<N extends number, Acc extends number[] = []> = Acc['length'] extends N
  ? Acc[number]
  : Enumerate<N, [...Acc, Acc['length']]>;

export type NumberRange<F extends number, T extends number> = Exclude<
  Enumerate<T>,
  Enumerate<F>
>;

export enum MouseKey {
  Left = 1,
  Right = 2,
  Middle = 4,
}

export enum KeyboardKeys {
  S = 's',
  Plus = '+',
  Minus = '-',
  Zero = '0',
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
  PageUp = 'PageUp',
  PageDown = 'PageDown',
  Space = ' ',
  Home = 'Home',
  End = 'End',
  F2 = 'F2',
  F4 = 'F4',
  F5 = 'F5',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  F11 = 'F11',
  F12 = 'F12',
  c = 'c',
  v = 'v',
  Delete = 'Delete',
  F = 'f',
  A = 'a',
  Tab = 'Tab',
  Q = 'q',
  X = 'x',
}

export const ArrowKeys = [
  KeyboardKeys.ArrowUp,
  KeyboardKeys.ArrowDown,
  KeyboardKeys.ArrowLeft,
  KeyboardKeys.ArrowRight,
];

export const VerticalArrowKeys = [KeyboardKeys.ArrowUp, KeyboardKeys.ArrowDown];
export const HorizontalArrowKeys = [KeyboardKeys.ArrowLeft, KeyboardKeys.ArrowRight];

export enum AccessRightType {
  VISIBLE = 1,
  READ = 2,
  MODIFY = 3,
}

export enum ExplorerFocusArea {
  None,
  TreeView,
  ChildrenView,
}
